module.exports = __webpack_public_path__ + "img/1.0a7c24e0.jpg";